import { object, string, ref } from 'yup';
import { TFunction } from 'i18next';

export function makePasswordEditSchema(t: TFunction) {
  return object().shape({
    password: string().required(t('form.required')),
    passwordAgain: string()
      .required(t('form.required'))
      .oneOf([ref('password'), null] as any, t('form.mustMatch')),
  });
}
